import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Sidebar from './components/layout/Sidebar';
import Topbar from './components/layout/Topbar';
import PageSkeleton from './components/layout/PageSkeleton';

const Home = lazy(() => import('./pages/Home/Home'));
const News = lazy(() => import('./pages/News/News'));
const List = lazy(() => import('./pages/List/List'));
const User = lazy(() => import('./pages/User/User'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));

const App = () => {
  return (
    <ThemeProvider>
      <Router>
        <a
          href="#main-content"
          className="sr-only-focusable fixed left-4 top-4 z-50 rounded-lg bg-accent-600 px-4 py-2 text-sm font-medium text-white"
        >
          Skip to content
        </a>

        <div className="min-h-screen bg-bg">
          <Sidebar />

          <div className="lg:pl-[76px]">
            <Topbar />

            <main id="main-content" className="px-4 pb-24 pt-6 md:px-6 lg:pb-10">
              <Suspense fallback={<PageSkeleton />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/list" element={<List />} />
                  <Route path="/user" element={<User />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </main>
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;
